import { Outlet } from 'react-router-dom';
import { LandingNavbar, LandingFooter } from '~/components/module/landing';
import { PageTransition } from '~/components/common';

const Landing: React.FC = () => {
  //#region Declare Hook
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function

  return (
      <div className='min-h-screen bg-lumi-dark-300 landing-layout transition-colors duration-300'>
      <LandingNavbar />
      <main>
        <PageTransition>
          <Outlet />
        </PageTransition>
      </main>
      <LandingFooter />
    </div>
  );
};

export default Landing;
